import { ArrowRight } from '@phosphor-icons/react';
import type { Expertise } from '../../content/site';
import type { Surface } from './surfaces';

type PartProps = {
	item: Expertise;
	surface: Surface;
	className?: string;
};

/** Lead line and explanation. Each block carries data-reveal for the accordion stagger. */
export function ExpertiseSummary({ item, surface, className = '' }: PartProps) {
	return (
		<div className={className}>
			<p
				data-reveal
				className={`max-w-[34ch] text-[clamp(1.125rem,1.45vw,1.3125rem)] font-medium leading-snug tracking-[-0.01em] ${surface.ink}`}
			>
				{item.short}
			</p>
			<p data-reveal className={`mt-3 max-w-[56ch] text-base leading-relaxed ${surface.soft}`}>
				{item.body}
			</p>
		</div>
	);
}

/** Three concrete examples, then the stack. */
export function ExpertiseFacts({ item, surface, className = '' }: PartProps) {
	return (
		<div className={className}>
			<ul data-reveal className={`grid gap-2.5 text-[0.9375rem] leading-snug ${surface.ink}`}>
				{item.examples.map((example) => (
					<li key={example} className="grid grid-cols-[1rem_minmax(0,1fr)] gap-3">
						<ArrowRight aria-hidden size={16} weight="bold" className={`mt-[0.15em] ${surface.mark}`} />
						<span>{example}</span>
					</li>
				))}
			</ul>
			<ul data-reveal className="mt-6 flex flex-wrap gap-2">
				{item.stack.map((tech) => (
					<li
						key={tech}
						className={`rounded-full px-3 py-1.5 font-mono text-[0.75rem] leading-none ${surface.tag}`}
					>
						{tech}
					</li>
				))}
			</ul>
		</div>
	);
}
